import { render, staticRenderFns } from "./ContentLoans.vue?vue&type=template&id=cb2f9cfc"
import script from "./ContentLoans.vue?vue&type=script&lang=js"
export * from "./ContentLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports